import searchService from '../api/search'

const categoryKeys = {
    ARTISTIC_FIELD: 'artistic_field',
    HEADING: 'heading',
    LOCATION: 'location',
}

const state = {
    searchResults: null,
    categories: null,
    lastQuery: null,
}

const getters = {
    groupedResults: (state) => {
        const results = state.searchResults;

        if (!results) {
            return {};
        }

        return results.items.reduce((acc, result) => {
            const model = result.model;
            acc[model] = acc[model] || [];
            acc[model].push(result);
            return acc;
        }, {});
    },

    getHeadingSubcategories: state => {
        return state.categories &&
            state.categories
                .find(category => category.key === categoryKeys.HEADING).subcategories.slice()
                .sort((a, b) => a.name.localeCompare(b.name));
    }
}

const actions = {
    search({state, commit, dispatch}, { query, types = null, subcategories = null, from = null, to = null })
    {
        commit('setLastQuery', query);

        return searchService.searchV2(
            query,
            types?.map(type => type.type),
            subcategories,
            from,
            to,
        ).then(response => {
            const result = response.data

            commit('setSearchResults', result)

            return result
        }, () => false)
    },

    getCategories({state, commit}) {
        return searchService.categories().then(response => {
            const result = response.data

            commit('setCategories', result)

            return result
        }, () => false)
    },

    clearSearchResults({ commit }) {
        commit('clearSearchResults');
    },
}

const mutations = {
    setSearchResults(state, results) {
        state.searchResults = results
    },
    setCategories(state, categories) {
        state.categories = categories
    },
    setLastQuery(state, query) {
        state.lastQuery = query;
    },
    clearSearchResults(state) {
        state.searchResults = null;
        state.lastQuery = null;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
